import {
    baseUrl
} from '@/config/env';
import request from '@/router/axios';
import {
    parseParam
} from '@/util/util';

export const findProjectList = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-work/v2/project?` + params,
        method: 'GET'
    })
}

export const findAgentId = (staffId) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/stuff/findRootDepartIdByStaffId/${staffId}`,
        method: 'GET'
    })
}
export const findProject = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-work/v2/project/select?` + params,
        method: 'GET'
    })
}
// 检查预约卡号是否存在
export const checkCardNumber = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-work/v2/app-project/selectChild?` + params,
        method: 'GET'
    })
}
export const findProjects = () => {
    return request({
        url: `${baseUrl}/joins-work/v2/project/projects`,
        method: 'GET'
    })
}
export const findAllSuperiorDepartment = () => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/department/findAllSuperiorDepartment`,
        method: 'GET'
    })
}
export const addProject = (params) => {
    return request({
        url: `${baseUrl}/joins-work/v2/project`,
        method: 'POST',
        data: params
    })
}
export const delProject = (deleteOption, ids) => {
    let temp = ids.join(",")
    return request({
        url: `${baseUrl}/joins-work/v2/project/${temp}?option=${deleteOption}`,
        method: 'DELETE'
    })
}
export const findProvince = () => {
    return request({
        url: `${baseUrl}/joins-basic/v1/province`,
        method: 'GET'
    })
}
export const findCitys = (id) => {
    return request({
        url: `${baseUrl}/joins-basic/v1/province/citys/${id}`,
        method: 'GET'
    })
}
export const findAreas = (id) => {
    return request({
        url: `${baseUrl}/joins-basic/v1/province/areas/${id}`,
        method: 'GET'
    })
}
export const findServiceItemDetail = (id) => {
    return request({
        url: `${baseUrl}/joins-basic/v1/province/areas/${id}`,
        method: 'GET'
    })
}
export const editProject = (params) => {
    return request({
        url: `${baseUrl}/joins-work/v2/project`,
        method: 'PUT',
        data: params
    })
}
export const delItem = (deleteOption, ids) => {
    let temp = ids.join(",")
    return request({
        url: `${baseUrl}/joins-work/v2/project/${temp}?option=${deleteOption}`,
        method: 'DELETE'
    })
}